<template>
  <div>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>项目明细</b>
      </div>
      <div class=' contijiao wkbmf loaded' v-if="tibaoif">
        <div class='stamp'> </div>
      </div>
      <el-row class="rowdig">
        <el-col :span="6" class="infodata1">
          <span><b>询价单号:</b></span> <span>{{informdata.ccode}}</span>
        </el-col>
        <el-col :span="6" class="infodata1">
          <span><b>询价开始:</b></span> <span>{{informdata.dxjstart}}</span>
        </el-col>
        <el-col :span="6" class="infodata1">
          <span><b>询价截止:</b></span> <span>{{informdata.dxjend}}</span>
        </el-col>
        <el-col :span="6" class="infodata1">
          <span><b>订单类型:</b></span> <span>{{informdata.cordertype}}</span>
        </el-col>
        <el-col :span="12" class="infodata1">
          <span><b>物料描述:</b></span> <span>{{informdata.cinvname}}</span>
        </el-col>
        <el-col :span="6" class="infodata1">
          <span><b>规格:</b></span> <span>{{informdata.cspecification}}</span>
        </el-col>
        <el-col :span="6" class="infodata1">
          <span><b>单位:</b></span> <span>{{informdata.cunit}}</span>
        </el-col>
        <el-col :span="24" class="">
          <span style="width:75px;"><b>工厂描述:</b></span> <span style="display: block;width: calc( 100% - 100px);float: right;vertical-align: top;margin-left: 0;">{{informdata.cremark}}</span>
        </el-col>
      </el-row>

    </el-card>
    <div id="out-table">
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <b><i class="el-icon-s-unfold"></i>报价说明</b>
          <span :style="'color:'+color+';margin-left:15px'">{{spantitle}}</span>
        </div>
        <div class="text item text-center" style="width:100%;height:60px;">
          <div class="pull-right" style="margin-bottom:15px">
            <!-- <el-button type="primary" plain size="medium">付款条款</el-button> -->
            <el-button type="success" plain @click.native="SaveNextPrice()" size="medium" v-if="informdata.cfxjid != ''">获取上次价格</el-button>
            <!-- <el-button type="primary" plain size="medium" @click="GetInvbillNorm">质量要求</el-button> -->
            <el-button type="warning" plain @click.native="downfile()" size="medium">招标文件下载</el-button>
            <el-button type="warning" plain @click.native="down()" size="medium" :disabled="tibaoif">报价单模板下载</el-button>
            <el-upload style="display:inline-block;margin:0 10px" action="#" :show-file-list="false" ref="uploadFail" :disabled="tibaoif" :before-upload="brforeUploadreImportFail" :auto-upload="false" :on-change="handleChangeFail" :file-list="fileListFail" :accept="typeaccept">
              <el-button type="success" plain size="medium" :disabled="tibaoif">报价单上传({{typeaccept}})</el-button>
            </el-upload>
            <!-- <el-button type="warning" size="medium" @click="down()">报价单下载</el-button> -->
            <el-button type="warning" plain @click.native="GetHTFileUrl()" size="medium">预览</el-button>
            <el-button type="success" plain @click.native="checktable('1')" size="medium" :disabled="tibaoif">价格暂存</el-button>
            <el-button type="primary" @click.native="checktable('2')" size="medium" :disabled="tibaoif">价格提报</el-button>
            <el-button type="danger" plain @click.native="UnPriceSubmit()" size="medium" :disabled="!tibaoif">撤销报价</el-button>
            <el-button type="info" plain size="medium" @click="returnpage('1')">返回主表</el-button>
            <el-button type="info" plain size="medium" @click="returnpage('2')">返回首页</el-button>
          </div>
        </div>
        <!-- 可以使用span 和 span-map对象来控制栅格的大小 -->

        <table cellspacing="0" cellpadding="0" class="Projectdetails">
          <tr>
            <td style="width:130px">报价有效期(天)</td>
            <td style="width:110px">
              <el-input size="small" v-model="quoform.iquotation" :disabled="tibaoif" placeholder="请输入有效期" oninput="value=value.replace(/[^\([0-9]|[0-9]\\d|100]/g,'')"></el-input>
              <!-- <el-date-picker v-model="quoform.dquotation" :disabled="tibaoif" type="date" placeholder="选择有效期" value-format="yyyy-mm-dd"></el-date-picker> -->
            </td>

            <td style="width:80px">税率(%)</td>
            <td style="width:140px">
              <el-select v-model="quoform.cmwskz" filterable placeholder="请选择" :disabled="tibaoif">

              </el-select>
            </td>
            <td style="width:80px">报价单</td>
            <td style="min-width:110px">
              {{quoform.cquotation_grive}}
            </td>
            <td>备注</td>
            <td>
              <el-input size="small" v-model="quoform.cpriceremark" :disabled="tibaoif" placeholder="请输入备注"></el-input>
            </td>
          </tr>
        </table>
      </el-card>
      <el-card class="box-card boxcard">
        <div slot="header" class="clearfix">
          <b><i class="el-icon-s-unfold"></i>报价详情</b>
          <span style="color:#ff0000;margin-left:15px;font-size:15px"><b>含税单价最多四位小数,注意计量单位，如果填错，会导致报价失败！</b></span>
        </div>
        <el-table :data="tableData" style="width: 100%;background: transparent" max-height="420" :header-cell-style="{background:'#eef1f6',color:'#606266'}" border class="tb-edit" row-key="id" :row-class-name="rowClassName" highlight-current-row>
          <el-table-column prop="id" label="序号" width="50"></el-table-column>
          <el-table-column label="工厂" prop="cpasturename_price"></el-table-column>
          <!-- 没修改字段把送货地点改成了报价单位 -->
          <el-table-column label="计量单位" prop="cmainunit_price" width="90"></el-table-column>
          <el-table-column label="询价数量" prop="ipricenum" width="110"></el-table-column>
          <el-table-column label="送达方名称"prop="cjhname" width="110"></el-table-column>
          <el-table-column label="含税单价" width="110">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.iyf_price" v-if="!tibaoif"></el-input>
              <span>{{scope.row.iyf_price}}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否供货" width="110">
            <template slot-scope="scope">
              <el-select size="small" v-model="scope.row.cisdeliver" placeholder="请选择" v-if="!tibaoif">
                <el-option label="供货" value="供货"></el-option>
                <el-option label="不供货" value="不供货"></el-option>
              </el-select>
              <span>{{scope.row.cisdeliver}}</span>
            </template>
          </el-table-column>
          <el-table-column label="报价说明">
            <template slot-scope="scope">
              <el-input size="small" type="textarea" v-model="scope.row.cpriceremark" placeholder="请输入报价说明" v-if="!tibaoif"></el-input>
              <span>{{scope.row.cpriceremark}}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注信息">
            <template slot-scope="scope">
              <span>{{scope.row.cccompanymark}}</span>
            </template>
          </el-table-column>
          <el-table-column label="赠品" width="60" prop="czsnumber"></el-table-column>
          <el-table-column label="赠品维护" width="200">
            <template slot-scope="scope">
              <el-button type="primary" plain size="mini" @click="addzengpin(scope.row,'1',scope.$index)" v-if="!tibaoif && scope.row.czsnumber=='无'">赠品新增</el-button>
              <el-button type="primary" plain size="mini" @click="addzengpin(scope.row,'2',scope.$index)" v-if="scope.row.czsnumber=='有'">赠品查看</el-button>
            </template>
          </el-table-column>
          <el-table-column label="质量要求" width="120">
            <template slot-scope="scope">
              <el-button type="primary" plain size="mini" @click="GetInvbill(scope.row)">质量要求</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <word ref="wordown" v-if="wordif" v-show="false" :tableData="printtabledata" :informdata="informdata" />
      <zengpin :zengpinrow="zengpinrow" :dialogVisible="dialogVisible" @czsnumber="czsnumber" @dialog="dialog" v-if="dialogVisible" :wuliaoData="wuliaoData" :tibaoif="tibaoif" :crm="crm" />
      <filedown v-if="disfiles" :tableData2="tableData2" :disfiles="disfiles" @disfilesbtn="disfilesbtn" />
    </div>
  </div>
</template>

<script>
import word from "../../../../components/wordhtmldown.vue";
import { RemovePruchaseToDo, GetFileType } from "../../../../api/home";
import zengpin from "./zengpin.vue";
import filedown from "./filedown.vue";
export default {
  components: {
    word,
    zengpin,
    filedown,
  },
  data() {
    return {
      zengpinrow: {},
      informdata: {
        // 询价单号
        ccode: "",
        // 询价开始时间
        dxjstart: "",
        // 询价截至时间
        dxjend: "",
        // 订单类型
        cordertype: "",
        // 物料描述
        cinvname: "",
        // 规格
        cspecification: "",
        // 单位
        cunit: "",
        // 提交人
        ccommit: "",
        // 提交日期
        dcommit: "",
        //上次报价id
        cfxjid: "",
      },
      quoform: {
        // 报价有效期
        dquotation: "",
        //  税码
        cmwskz: "",
        // 税率名称
        ctaxname: "",
        // 税率
        itaxrate: "",

        // 赠品描述
        cgiveawayms: "",
        // 报价单
        cquotation_grive: "",
        // 报价单路径
        cquotation_url: "",
      },
      tableData: [],
      fileListFail: [],
      tibaoif: false,
      suprow: {},
      spantitle: "",
      day: 0,
      hr: 0,
      min: 0,
      sec: 0,
      color: "",
      typeaccept: "",
      dialogVisible: false,
      wordif: false,
      selectitax: [],

      wuliaoData: {
        csrminvcode: "",
        cinvname: "",
        izpbl_price: "",
        cmainunit: "",
        izsnumber: "",
      },
      crm: "1",
      zengpinrow: {},
      scopeindex: "",
      ctestindex: "",
      newtabel: [],
      // 文件下载
      disfiles: false,
      tableData2: [],
      previnformdata: {},
      printtabledata: [],
    };
  },
  created() {
    if (this.$route.params.rows) {
      this.suprow = this.$route.params.rows;
      sessionStorage.setItem("suprow", JSON.stringify(this.$route.params.rows));

      if (this.$route.params.informdata != "undefined") {
        this.previnformdata = this.$route.params.informdata;
        sessionStorage.setItem(
          "informdata",
          JSON.stringify(this.$route.params.informdata)
        );
      }
    } else {
      if (sessionStorage.getItem("informdata") != "undefined") {
        this.previnformdata = JSON.parse(sessionStorage.getItem("informdata"));
      }
      if (sessionStorage.getItem("suprow") != "undefined") {
        this.suprow = JSON.parse(sessionStorage.getItem("suprow"));
      }
    }
    this.GetInquiryInfo();
    this.FileType();
    /*获取下载模板信息*/
    this.getprintdata();
    this.GetTaxRatelList();
  },
  methods: {
    // 文件下载传值
    disfilesbtn(val) {
      this.disfiles = val;
    },
    // 关闭
    dialog(val) {
      this.dialogVisible = val;
    },
    // 赠品保存
    czsnumber(val) {
      this.tableData[this.scopeindex].czsnumber = val;
    },
    // 文件下载列表
    downfile() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetNonInquiryFile",
        data: { KeyValue: this.suprow.id },
      }).then((res) => {
        console.log(res, "获取信息结果");
        if (res.data.Success) {
          this.tableData2 = res.data.Data;
        } else {
          this.$message.error(res.data.Message);
        }
      });
      this.disfiles = true;
    },
    // 赠品弹框
    addzengpin(row, type, index) {
      this.zengpinrow = row;
      this.scopeindex = index;

      this.wuliaoData = {
        csrminvcode: "",
        cinvname: "",
        izpbl_price: "",
        cmainunit: "",
        izsnumber: "",
      };
      if (type == "1") {
        this.crm = "1";
        this.dialogVisible = true;
        this.wuliaoData.csrminvcode = row.csrminvcode_price;
        this.wuliaoData.cmainunit = row.cunit_price;
        this.wuliaoData.cinvname = row.cinvname_price;
      } else if (type == "2") {
        this.GetInvbillInfo(row);
      }
    },
    // 查看
    GetInvbillInfo(row) {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetGiveawayInvbillInfo",
        data: {
          autoid: row.op_inquiry_price_autoid,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          if (res.data.Data[0].czssrminvname == "") {
            this.dialogVisible = false;
            this.$message.error("暂无赠品信息！");
          } else {
            this.dialogVisible = true;

            this.wuliaoData = {
              csrminvcode: res.data.Data[0].czssrminvcode,
              cinvname: res.data.Data[0].czssrminvname,
              izpbl_price: res.data.Data[0].izpbl_price,
              cmainunit: res.data.Data[0].czpunit_price,
              izsnumber: res.data.Data[0].izsnumber,
            };
          }
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },

    // 校验指标
    GetInvbillNorm() {
      if (this.ctestindex != undefined) {
        this.$alert(`${this.ctestindex}`, "质量要求", {
          confirmButtonText: "确定",
        });
      }
    },
    // 校验指标
    GetInvbill(row) {
      console.log(row);
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetInvbillNorm",
        data: {
          KeyValue: row.op_inquiry_price_id,
          cinvcode: row.csrminvcode_price,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          if (res.data.Data[0] != undefined) {
            if (res.data.Data[0].ctestindex == "") {
              this.ctestindex = "暂无质量要求信息！";
            } else {
              this.ctestindex = res.data.Data[0].ctestindex;
            }

            for (let a = 0; a < this.newtabel.length; a++) {
              this.$set(this.newtabel[a], "ctestindex", this.ctestindex);
            }
            this.GetInvbillNorm();
            console.log(this.newtabel, "校验");
          }
        } else {
          //this.$message.error(res.data.Message);
        }
      });
    },

    // 税率
    GetTaxRatelList() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetTaxRatelList",
      }).then((res) => {
        console.log(res, "税率");
        if (res.data.Success) {
          this.selectitax = res.data.Data;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 剩余时间
    countdown() {
      // console.log(this.informdata.dxjend);
      if (this.informdata.dxjend && this.informdata.dxjend != "") {
        const end = new Date(this.informdata.dxjend); // 定义开始时间且延长1小时
        const now = Date.parse(new Date()); // 获取本地时间
        const msec = end - now;
        // 将时间戳进行格式化00：00的形式
        let day = parseInt(msec / 1000 / 60 / 60 / 24);
        let hr = parseInt((msec / 1000 / 60 / 60) % 24);
        let min = parseInt((msec / 1000 / 60) % 60);
        let sec = parseInt((msec / 1000) % 60);
        this.day = day;
        this.hr = hr > 9 ? hr : "0" + hr;
        this.min = min > 9 ? min : "0" + min;
        this.sec = sec > 9 ? sec : "0" + sec;
        this.color = "red";
        this.spantitle =
          "询价剩余时间" +
          this.day +
          ":" +
          this.hr +
          ":" +
          this.min +
          ":" +
          this.sec;
        if (msec < 0 || this.tableData[0].cisreport == "已提报") {
          this.color = "#67c23a";
          this.spantitle = "已停止报价";
          return;
        } else if (
          this.tableData[0].cisreport != "已提报" &&
          this.informdata.cbigopen == "是"
        ) {
          this.spantitle = "报价通道已关闭";
          return;
        } else if (
          this.informdata.cbigopen != "是" &&
          this.suprow.cisreport != "已提报" &&
          msec > 0
        ) {
          const that = this;
          setTimeout(function () {
            that.countdown();
          }, 1000);
        }
      }
    },
    // 下载word
    down() {
      this.$refs.wordown.exportWord();
    },
    // 返回
    returnpage(type) {
      sessionStorage.removeItem("params");
      if (type == "1") {
        this.$router.push({
          path: "/SupInvoiceList/SupInvoiceList",
          query: { informdata: this.previnformdata },
        });
      } else {
        this.$router.push({ path: "/home" });
      }
    },
    getprintdata() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetPrintInfo",
        data: { keyId: this.suprow.id },
      }).then((res) => {
        console.log(res, "GetPrintInfoGetPrintInfoGetPrintInfo");
        this.loading = false;
        if (res.data.Success) {
          this.printtabledata = JSON.parse(JSON.stringify(res.data.Data));
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 获取信息
    GetInquiryInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetInquiryInfo",
        data: { KeyValue: this.suprow.id, cuscode: this.suprow.cvencode_price },
      }).then((res) => {
        console.log(res, "获取信息结果1111111111111111");
        this.loading = false;
        if (res.data.Success) {
          this.informdata = res.data.Data.dt[0];

          this.quoform = res.data.Data.dt3[0];

          this.wordif = true;
          // if(this.quoform.dquotation){
          //      this.$set(this.quoform, "dquotation", this.quoform.dquotation);
          // }
          this.tableData = res.data.Data.dt2;
          this.newtabel = JSON.parse(JSON.stringify(res.data.Data.dt2));

          if (this.tableData[0].cisreport == "已提报") {
            this.tibaoif = true;
          } else {
            this.tibaoif = false;
          }
          this.tableData.forEach((item, index) => {
            if (item.cisdeliver == "") {
              item.cisdeliver = "供货";
            }
          });
          this.countdown();
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    //  暂存
    SavePrice() {
      console.log(this.quoform);
      var json = {
        dt: [this.informdata],
        dt3: [this.quoform],
        dt2: this.tableData,
      };

      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/SavePrice",
        //    headers: {
        // 	'Content-Type': 'application/x-www-form-urlencoded'
        //  },
        data: { KeyValue: this.suprow.id, JsonInfo: JSON.stringify(json) },
      }).then((res) => {
        console.log(res, "暂存结果");

        if (res.data.Success) {
          this.$message.success(res.data.Message);
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 判断调价暂存和提报
    checktable(type) {
      var throwtrur;
      if (this.quoform.cmwskz) {
        for (var a = 0; a < this.selectitax.length; a++) {
          if (this.selectitax[a].ctaxcode == this.quoform.cmwskz) {
            this.quoform.ctaxname = this.selectitax[a].ctaxname;
            this.quoform.itaxrate = this.selectitax[a].itax;
          }
        }
      }
      this.tableData.forEach((item, index) => {
        let no = index + 1;
        if (item.cisdeliver == "") {
          this.$message.error("报价详情第" + no + "行：请选择是否供货！");
          throwtrur = false;
          throw console.info("信息不完整");
        } else if (item.iyf_price === "") {
          this.$message.error("报价详情第" + no + "行：含税报价不能为空！");
          throwtrur = false;
          throw console.info("信息不完整");
        } else if (
          (item.iyf_price < 0 || item.iyf_price == 0) &&
          item.cisdeliver == "供货" &&
          item.cpriceremark == ""
        ) {
          this.$message.error("报价详情第" + no + "行：请填写含税报价！");
          throwtrur = false;
          throw console.info("信息不完整");
        } else if (item.iyf_price != 0 && item.cisdeliver == "不供货") {
          this.$message.error(
            "报价详情第" + no + "行：已经选择了不供货，含税报价必须为0"
          );
          throwtrur = false;
          throw console.info("信息不完整");
        } else {
          throwtrur = true;
        }
      });
      if (throwtrur == true) {
        if (type == "1") {
          this.SavePrice();
        }
        if (type == "2") {
          if (this.quoform.cquotation_url == "") {
            this.$message.error("请上传报价单！！");
            throw console.info("信息不完整");
          } else if (
            this.quoform.iquotation == "" ||
            this.quoform.iquotation == 0
          ) {
            this.$message.error("报价有效期不能为空或为0");
            throw console.info("信息不完整");
          } else if (this.quoform.cmwskz == "") {
            this.$message.error("请输入税率！");
            throw console.info("信息不完整");
          } else {
            this.PriceSubmit();
          }
        }
      }
    },
    //  提报
    PriceSubmit() {
      if (this.quoform.cmwskz) {
        for (var a = 0; a < this.selectitax.length; a++) {
          if (this.quoform.cmwskz == this.selectitax[a].ctaxcode) {
            this.quoform.ctaxname = this.selectitax[a].ctaxname;
            this.quoform.itaxrate = this.selectitax[a].itax;
          }
        }
      }
      this.$confirm(
        "此操作将提报该信息内容，提报之后将无法修改请确认是否提报",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          var json = {
            dt: [this.informdata],
            dt3: [this.quoform],
            dt2: this.tableData,
          };
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/PriceSubmit",
            data: { KeyValue: this.suprow.id, JsonInfo: JSON.stringify(json) },
          }).then((res) => {
            console.log(res, "提报结果");

            if (res.data.Success) {
              this.$message.success("提报成功！！");
              this.removerp();
              this.returnpage("1");
            } else {
              this.$message.error(res.data.Message);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消提报",
          // });
        });
    },
    // 获取文件类型
    FileType() {
      GetFileType({ type: "01" }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          this.typeaccept = res.data.Data[0].cfileformat;
        }
      });
    },
    // 删除待办事项中的信息
    removerp() {
      RemovePruchaseToDo({
        KeyValue: this.suprow.id,
      }).then((res) => {
        console.log(res);
      });
    },
    //  撤销报价
    UnPriceSubmit() {
      this.$confirm("此操作将撤销报价，请确认是否操作！！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/UnPriceSubmit",
            data: { KeyValue: this.suprow.id },
          }).then((res) => {
            console.log(res, "撤销结果");

            if (res.data.Success) {
              this.$message.success(res.data.Message);
              this.suprow.cisreport = "未提报";
              if (this.suprow.cisreport == "已提报") {
                this.tibaoif = true;
              } else {
                this.tibaoif = false;
              }

              // this.returnpage();
            } else {
              this.$message.error(res.data.Message);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消撤销报价",
          // });
        });
    },
    //上传文件
    handleChangeFail(file, fileList) {
      this.$refs.uploadFail.submit();
    },
    // 上传文件
    brforeUploadreImportFail(file) {
      let varparams = new FormData();
      varparams.append("file", file);
      varparams.append("file", URL.createObjectURL(file));
      varparams.append("cvoucherno", "op_inquiry");
      varparams.append("ctype", "01");
      varparams.append("cvoucherid", this.suprow.id);
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/SupplierCheckAll",
        data: { cbilltype: "报价单上传", cbillid: this.suprow.id },
      }).then((res) => {
        console.log(res, "上传结果上传结果上传结果上传结果");
        this.loading = false;
        if (res.data.Success) {
          // var varjson={cvoucherno:"op_inquiry_giveaway",ctype:"",cvoucherid:this.suprow.id}
          // console.log(file, "开始上传");
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/BaseUploadFile",
            headers: { "Content-Type": "multipart/form-data" },
            data: varparams,
            timeout: 30000000,
          }).then((res) => {
            console.log(res, "上传结果");
            this.loading = false;
            if (res.data.Success) {
              this.$message({
                howClose: true,
                message: "上传成功",
                type: "success",
              });

              this.quoform.cquotation_grive = res.data.Data.Cname;
              this.quoform.cquotation_url = res.data.Data.Path;
            } else {
              this.$message.error(res.data.Message);
            }
          });

          return false; //屏蔽了action的默认上传
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 预览
    GetHTFileUrl() {
      if (
        this.quoform.cquotation_url != "" &&
        this.quoform.cquotation_url != undefined
      ) {
        window.open(this.global.BASE_URL + this.quoform.cquotation_url);
      } else {
        this.$message.error("暂无文件！！");
      }
    },
    //  报价详情
    rowClassName({ row, rowIndex }) {
      //把每一行的索引放进row.id
      row.id = rowIndex + 1;
    },

    //获取上次报价
    SaveNextPrice() {
      this.$confirm("是否获取上次提报价格？", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        // this.$message({
        //   type: "info",
        //   message: "确定",
        // });
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SaveNextPrice",
          data: {
            KeyValue: this.suprow.id,
          },
        }).then((res) => {
          console.log(res, "获取上次提报价格");
          if (res.data.Success) {
            this.$message.success(res.data.Message);
            location.reload();
          } else {
            this.$message.error(res.data.Message);
          }
        });
      });
      // .catch((action) => {
      //   this.$message({
      //     type: "info",
      //     message: "取消",
      //   });
      // });
    },
  },
  beforeDestroy() {
    this.informdata = {};
  },
};
</script>
<style scoped>
.el-card__header .clearfix span {
  font-size: 12px;
}
.Projectdetails >>> .el-input__inner {
  border: 0;
  background: #f7f7f7;
}
.tb-edit .el-input,
.tb-edit .el-select,
.tb-edit .el-textarea {
  display: none;
}
.tb-edit .current-row .el-input,
.tb-edit .current-row .el-select,
.tb-edit .current-row .el-textarea {
  display: block;
}
.tb-edit .current-row .el-input + span,
.tb-edit .current-row .el-select + span,
.tb-edit .current-row .el-textarea + span {
  display: none;
}
.infodata {
  margin-bottom: 10px;
}
.infodata span {
  margin: 0 10px;
}
.Projectdetails /deep/ .el-input.is-disabled /deep/ .el-input__inner {
  border-color: transparent;
  background: transparent;
  color: #606266;
}
</style>